import { render, staticRenderFns } from "./CustomerConfirmForm.vue?vue&type=template&id=084144c9&scoped=true"
import script from "./CustomerConfirmForm.vue?vue&type=script&lang=js"
export * from "./CustomerConfirmForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "084144c9",
  null
  
)

export default component.exports